import { useEffect, useState } from 'react';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';

const useConnectWithGoogleIntegrationOnMount = (code: string | null) => {
    const { t } = useTranslation('newNotifications');
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const navigate = useNavigate();
    const [isReady, setIsReady] = useState(false);

    const generateTokens = (code: string) => {
        const { exec, abort } = userApi.connectGoogleIntegration({
            body: { code },
            onSuccess: _ => {
                toastHandler.push('success', t('googleIntegration.connectTitle'), t('googleIntegration.connectSuccess'));
                navigate('/integrations/google');
            },
            onError: _ => {
                toastHandler.push('error', t('googleIntegration.connectTitle'), t('googleIntegration.connectError'));
                navigate('/integrations');
            },
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    };

    useEffect(() => {
        if (code) generateTokens(code);
    }, []);

    return { isReady };
};

export default useConnectWithGoogleIntegrationOnMount;
